define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/query",
	"dojo/when",
	"dijit/form/Button",
	"dijit/registry",
	"dijit/Toolbar",
	"dijit/MenuItem",
	"dijit/form/DropDownButton",
	"csi/widget/DropDownMenu",
	"dgrid/editor",
	"dgrid/OnDemandGrid",
	"dgrid/extensions/DijitRegistry",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"csi/message",
	"csi/widget/MessageDialog"
], function(declare, lang, domClass, query, when, Button, registry, Toolbar, MenuItem, DropDownButton, DropDownMenu, editor, OnDemandGrid, GridDijitRegistry, _, html, locale, message, MessageDialog) {

	var _Toolbar = declare(Toolbar, {
		postCreate: function() {
			// summary: populate toolbar buttons
			this.inherited(arguments);

			if (!this.get("disabled")) {
				_.each(this.buttons, function(button) {
					var item = null;

					//Add buttons or dropdown menu based on button parameters
					var btnName = _.escape(locale.resource(button.name));

					if (button.children) {
						var menu = new DropDownMenu();
						var self = this;
						_.each(button.children, function(val) {
							var newItem = new MenuItem({
								"class": "csi-dropdown-item",
								disabled: val.disabledCallback ? val.disabledCallback(self.data) : false,
								label: locale.resource(val.label),
								onClick: function(e) {
									self._onButton(val);
								}
							});

							menu.addChild(newItem);
						});
						menu.startup();

						var item = new DropDownButton({
							"class": button["class"] || "",
							materialIcon: button.icon,
							showLabel: button.showLabel || false,
							label: btnName,
							title: btnName,
							dropDown: menu
						});

					} else {
						item = new Button({
							materialIcon: button.icon,
							showLabel: false,
							title: btnName,
							onClick: lang.hitch(this, this._onButton, button)
						});
					}

					this.addChild(item);
				}, this);
			}
		},

		_onButton: function(/*Object*/button) {
			// summary: call grid method
			this.grid[button.callback](this.grid.row(this.domNode), button);
		}
	});

	return declare([OnDemandGrid, GridDijitRegistry], {
		// Boolean: indicate if list items can be deleted
		bDelete: true,

		// Boolean: show delete confirmation
		bConfirmDelete: false,

		// String to pass as parameter to confirmDeletePrompt ("Delete_Prompt":"${Delete} ${0}?")
		confirmDeletePromptEntity: "",

		// String: delete confirmation window title
		confirmDeletePrompt: "Delete_Prompt",

		// String: delete confirmation window message
		confirmDeleteMessage: "Delete_Message",

		// Boolean: indicate if list is ordered (presents up/down actions)
		//bOrdered: false,

		// Boolean: true while grid is being refreshed
		//bRefreshing: false,

		// Boolean: indicate if there must always be at least one entry
		//bRequireOne: false,

		// Object[]: array of additional customer actions
		//customActions: [],

		// Boolean: indicate if list actions are disabled
		//disabled: false,

		// Function: return new object to be added to store
		//onNew: null,

		// extension points
		allowNew: function() {return true;},
		onDelete: function(row) {},
		onMove: function(row) {},
		onRefresh: function() {},
		newToolbarParam: {
			buttons: [{name: "Add", icon: "add", callback: "_onNew"}],
			"class": "dgrid-cell-padding"
		},

		buildRendering: function() {
			// summary: add new button
			this.inherited(arguments);

			if (this.onNew) {
				this.newToolbarParam.grid = this;
				this._newToolbar = new _Toolbar(this.newToolbarParam).placeAt(this.bodyNode);
			}

			domClass.add(this.domNode, "csi-dgrid-manager");

			if (!this.noDataMessage) {
				domClass.add(this.domNode, "no-data-message");
			}

			this.on("dgrid-datachange", lang.hitch(this, this._onDataChange));
		},

		configStructure: function() {
			// summary: add actions column to existing columns
			this._addActionsColumn();
			this.inherited(arguments);
		},

		copyRow: function(/*Object*/row) {
			// summary: copy given row data and add after given row
			var e = row.element.nextSibling;
			var rowNext = e && this.row(e);
			this._addItem(this.onNew(row.data), rowNext ? {before: rowNext.data} : null);
		},

		destroy: function() {
			if (this._newToolbar) {
				this._newToolbar.destroy();
			}

			this.inherited(arguments);
		},

		focusFirst: function() {
			// summary: focus on first cell
			var node = query(".dgrid-cell", this.contentNode)[0];
			if (node) {
				this.edit(node);
			}
		},

		insertRow: function(object, parent, beforeNode, i, options) {
			// summary: focus on new row
			var row = this.inherited(arguments);
			var editColumn = this.editColumn;

			this.editColumn = null;
			this._updateNew();

			if (editColumn) {
				_.defer(function(grid) {
					// in some cases we can get here with out of date row, so ignore
					if (row && row.parentNode) {
						grid.edit(grid.cell(row, editColumn));
					}
				}, this);
			}

			return row;
		},

		isLastRow: function(/*Object*/row) {
			// summary: determine if next sibling is also a grid row - if not, then given row is the last
			var e = row.element.nextSibling;
			return !e || !this.row(e);
		},

		refresh: function() {
			// summary: when refresh is done, then set visibility of "new" row and call refresh extension point
			this.bRefreshing = true;

			when(this.inherited(arguments), lang.hitch(this, function() {
				this.bRefreshing = false;
				this._updateNew();
				this.onRefresh();
			}));
		},

		validateChildren: function(/*Boolean*/bFocus) {
			// summary: validate widgets in grid, focusing on invalid widgets if desired
			var children = registry.findWidgets(this.domNode);

			return _.every(children, function(w) {
				if (!w.validate) {
					return true;
				}

				// make sure widget sets state if invalid
				w._hasBeenBlurred = true;

				if (w.validate()) {
					return true;
				}

				if (bFocus) {
					w.focus();
				}

				return false;
			});
		},

		_addItem: function(/*Object*/item, /*Object?*/options) {
			// summary: add item to store
			this.editColumn = this._columns[0].id;
			this.store.add(item, options);
		},

		_getNextRow: function(/*Object*/row, /*Boolean*/bDown) {
			// summary: get next row up or down from given row - grid will return same
			// row if at top or bottom
			var rowNext = bDown ? this.down(row) : this.up(row);
			return (row.element == rowNext.element) ? null : rowNext;
		},

		_onDataChange: function(/*Event*/evt) {
			// summary: mark column changed so that focus can be restored to proper cell
			var n = query(".dijitFocused", evt.cell.row.element)[0];
			this.editColumn = n ? this.cell(n).column.id : null;
		},

		_onDelete: function(/*Object*/row, /*Object*/button) {
			// summary: delete object from store
			if (this.bConfirmDelete) {
				this._confirmDelete(row);
			} else {
				this._doDelete(row);
			}
		},

		_confirmDelete: function(/*Object*/row) {
			var self = this;
			new MessageDialog({
				destroyOnHide: true,
				buttons: [MessageDialog.BUTTON_DELETE + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL],
				message: locale.resource(this.confirmDeleteMessage),
				materialIcon: MessageDialog.ICON_ERROR,
				title: locale.resource(this.confirmDeletePrompt, [this.confirmDeletePromptEntity]),
				onResponse: function(key) {
					if (key == MessageDialog.BUTTON_DELETE) {
						self._doDelete(row);
					}
				}
			}).show();
		},

		_doDelete: function(/*Object*/row) {
			if (this.bRequireOne && !this._getNextRow(row) && !this._getNextRow(row, true)) {
				message.errorDialog({message: locale.resource("AtLeastOne")});
				return;
			}

			var id = this.store.getIdentity(row.data);
			this.store.remove(id);
			this.onDelete(row);
			this._updateNew();
		},

		_onMove: function(/*Object*/row, /*Object*/button) {
			// summary: move object down one row
			var rowBefore = this._getNextRow(row, button.down);

			// if the row is already at the top or bottom, then ignore
			if (!rowBefore) return;

			// when moving down, need to move before the one after next; grid will return
			// same row if it cannot move down, so need to handle that case specially
			if (button.down) {
				rowBefore = this._getNextRow(rowBefore, true);
			}

			this.store.put(row.data, {before: rowBefore ? rowBefore.data : null});
			this.onMove(row);
		},

		_onNew: function() {
			// summary: add empty item
			this._addItem(this.onNew());
		},

		_setDisabled: function(/*Boolean*/disabled) {
			// summary: if grid is disabled, then make all editable columns disabled and refresh
			this._set("disabled", disabled);
			this._updateEditableColumns();
			this.refresh();
		},

		/**
		 * Add action column if so configured
		 */
		_addActionsColumn: function() {
			const buttons = this.customActions ? this.customActions.splice(0) : [];

			if (this.bOrdered) {
				buttons.push({name: "Up", icon: "arrow_upward", callback: "_onMove", down: false});
				buttons.push({name: "Down", icon: "arrow_downward", callback: "_onMove", down: true});
			}

			if (this.bDelete) {
				buttons.push({name: "Remove", icon: "close", callback: "_onDelete"});
			}

			if (buttons.length) {
				this.columns = [...this.columns, editor({
					// Necessary to have access to row data do determine whether
					// or not to disable menu items in toolbar dropdown
					canEdit: function(object, value) {
						this.editorArgs.data = object;
						return true;
					},
					className: "dgrid-cell-actions",
					editor: _Toolbar,
					editorArgs: {
						buttons: buttons,
						grid: this
					},
					label: " ",
					sortable: false
				})];
			}

			this._updateEditableColumns();
		},

		_updateEditableColumns: function() {
			// summary: if grid is disabled, then disable all editable columns
			var b = this.disabled;

			_.each(this.columns, function(c) {
				if (!c.editor) {
					return;
				}

				c.editorArgs = c.editorArgs || {};

				if (b && !c._originalCanEdit && !c.editorArgs.disabled) {
					// wrap original canEdit function with own function to set disabled to true
					c._originalCanEdit = c.canEdit || Boolean;
					c.canEdit = function(obj, value) {
						var b = this._originalCanEdit(obj, value);
						if (b) this.editorArgs.disabled = true;
						return b;
					};
				} else if (!b && c._originalCanEdit) {
					// unwrap function
					c.editorArgs.disabled = false;
					c.canEdit = c._originalCanEdit;
					c._originalCanEdit = null;
				}
			});
		},

		_updateNew: function() {
			// summary: update visibility of new action
			if (this._newToolbar) {
				html.setVisible(this._newToolbar.domNode, !this.disabled && this.allowNew());
			}
		}
	});
});
